export default __webpack_public_path__ + "YMCA-Diabetes-Prevention-Program-Colored.svg";